import React from "react";

export function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M11.333 11.3335L13.9997 14.0002" stroke="#748494" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333Z" stroke="#748494" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function SharedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="5.33252" cy="5.67236" r="2.32764" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="11.3353" cy="6.3324" r="1.66736" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.33105 13.3357V12.6574C1.33105 11.1901 2.52022 10.001 3.98749 10.001H6.67795C8.14523 10.001 9.33439 11.1901 9.33439 12.6574V13.3357" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.335 10.001H12.0699C13.5372 10.001 14.7264 11.1901 14.7264 12.6574V13.3357" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PrivateIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.333 14H4.66634C3.92967 14 3.33301 13.4033 3.33301 12.6667V7.33333C3.33301 6.59667 3.92967 6 4.66634 6H11.333C12.0697 6 12.6663 6.59667 12.6663 7.33333V12.6667C12.6663 13.4033 12.0697 14 11.333 14Z" stroke="#061522" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.6663 6V4.66667C10.6663 3.194 9.47234 2 7.99967 2V2C6.52701 2 5.33301 3.194 5.33301 4.66667V6" stroke="#061522" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.999 9.6665C7.815 9.6665 7.66567 9.81584 7.667 9.99984C7.667 10.1838 7.81633 10.3332 8.00033 10.3332C8.18433 10.3332 8.33367 10.1838 8.33367 9.99984C8.33367 9.81584 8.18433 9.6665 7.999 9.6665" stroke="#061522" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
